// @ts-nocheck

const warn = (s) => {
  console.warn("[react-gtm]", s);
};

export default warn;
